import React, { useState, useEffect } from "react";

const PrivacyPolicy = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMobile(window.innerWidth <= 480);
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#2c2c2c",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isSmallMobile ? "8px" : isMobile ? "15px" : "40px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  };

  const contentStyle = {
    backgroundColor: "white",
    padding: isSmallMobile ? "15px" : isMobile ? "25px" : "60px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
  };

  const boxStyle = {
    backgroundColor: "#f8f8f8",
    padding: isSmallMobile ? "10px" : isMobile ? "15px" : "25px",
    border: "1px solid #ddd",
    marginBottom: isSmallMobile ? "20px" : isMobile ? "30px" : "40px",
  };

  const listStyle = {
    textAlign: "left",
    paddingLeft: "30px",
    margin: "20px 0",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div
          style={{
            textAlign: "center",
            padding: "20px 0",
            marginBottom: "20px",
          }}
        >
          <img
            src="/KinShieldIcon.png"
            alt="KinShield Logo"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
            style={{
              maxWidth: "100px",
              height: "auto",
              mixBlendMode: "multiply",
              borderRadius: "15px",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.3)",
              WebkitUserDrag: "none",
              userSelect: "none",
            }}
          />
        </div>
        <style>
          {`
            .privacy-policy ul,
            .privacy-policy ol {
              text-align: left !important;
              padding-left: 30px !important;
              margin: 20px 0 !important;
            }
            .privacy-policy li {
              text-align: left !important;
              margin: 12px 0 !important;
              line-height: 1.6;
            }
            .privacy-policy h1, .privacy-policy h2, .privacy-policy h3, .privacy-policy h4 {
              text-align: left !important;
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 400;
              margin-top: 40px;
              margin-bottom: 20px;
            }
            .privacy-policy h1 {
              font-size: 2.2em;
              margin-bottom: 30px;
              border-bottom: 2px solid #333;
              padding-bottom: 15px;
            }
            .privacy-policy h2 {
              font-size: 1.5em;
              margin-top: 50px;
              border-bottom: 1px solid #ccc;
              padding-bottom: 10px;
            }
            .privacy-policy h3 {
              font-size: 1.2em;
              margin-top: 35px;
            }
            .privacy-policy p {
              margin: 16px 0;
              text-align: justify;
            }
            .privacy-policy table {
              border-collapse: collapse;
              width: 100%;
              margin: 25px 0;
            }
            .privacy-policy th {
              background-color: #f5f5f5;
              color: #333;
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 400;
              text-align: left;
              padding: 15px;
              border: 1px solid #ddd;
            }
            .privacy-policy td {
              padding: 12px 15px;
              border: 1px solid #ddd;
              vertical-align: top;
            }
            .privacy-policy tr:nth-child(even) {
              background-color: #fafafa;
            }
            
            /* Mobile Responsive Styles */
            @media (max-width: 768px) {
              .privacy-policy h1 {
                font-size: 1.8em !important;
                margin-top: 20px !important;
                margin-bottom: 15px !important;
                padding-bottom: 10px !important;
              }
              .privacy-policy h2 {
                font-size: 1.3em !important;
                margin-top: 25px !important;
                margin-bottom: 10px !important;
                padding-bottom: 8px !important;
              }
              .privacy-policy h3 {
                font-size: 1.1em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .privacy-policy h4 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 8px !important;
              }
              .privacy-policy p {
                margin: 8px 0 !important;
              }
              .privacy-policy ul,
              .privacy-policy ol {
                padding-left: 20px !important;
                margin: 10px 0 !important;
              }
              .privacy-policy li {
                margin: 6px 0 !important;
              }
              .privacy-policy table {
                margin: 15px 0 !important;
                font-size: 0.9em;
              }
              .privacy-policy th,
              .privacy-policy td {
                padding: 8px 6px !important;
              }
            }
            
            @media (max-width: 480px) {
              .privacy-policy h1 {
                font-size: 1.6em !important;
                margin-top: 15px !important;
                margin-bottom: 12px !important;
              }
              .privacy-policy h2 {
                font-size: 1.2em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .privacy-policy h3 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 6px !important;
              }
              .privacy-policy h4 {
                font-size: 1em !important;
                margin-top: 12px !important;
                margin-bottom: 6px !important;
              }
              .privacy-policy p {
                margin: 6px 0 !important;
              }
              .privacy-policy ul,
              .privacy-policy ol {
                padding-left: 15px !important;
                margin: 8px 0 !important;
              }
              .privacy-policy li {
                margin: 4px 0 !important;
              }
              .privacy-policy table {
                margin: 10px 0 !important;
                font-size: 0.85em;
              }
              .privacy-policy th,
              .privacy-policy td {
                padding: 6px 4px !important;
              }
            }
          `}
        </style>
        <div className="privacy-policy">
          <h1>Privacy Policy</h1>

          <div style={boxStyle}>
            <p style={{ margin: "0 0 10px 0" }}>
              <strong>Effective Date:</strong> August 1, 2025
            </p>
            <p style={{ margin: "0" }}>
              <strong>Last Updated:</strong> June 26, 2026
            </p>
          </div>

          <div style={{ marginBottom: "40px" }}>
            <h2>Table of Contents</h2>
            <ol
              style={{
                lineHeight: "1.8",
                textAlign: "left",
                paddingLeft: "30px",
              }}
            >
              <li>
                <a
                  href="#information-we-collect"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Information We Collect
                </a>
              </li>
              <li>
                <a
                  href="#how-we-use-information"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  How We Use Your Information
                </a>
              </li>
              <li>
                <a
                  href="#information-sharing"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Information Sharing and Disclosure
                </a>
              </li>
              <li>
                <a
                  href="#data-security"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Data Security
                </a>
              </li>
              <li>
                <a
                  href="#data-retention"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Data Retention
                </a>
              </li>
              <li>
                <a
                  href="#your-rights"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Your Rights and Choices
                </a>
              </li>
              <li>
                <a
                  href="#cookies"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Cookies and Tracking Technologies
                </a>
              </li>
              <li>
                <a
                  href="#third-party-services"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Third-Party Services
                </a>
              </li>
              <li>
                <a
                  href="#business-corporate-accounts"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Business and Corporate Accounts
                </a>
              </li>
              <li>
                <a
                  href="#international-transfers"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  International Data Transfers
                </a>
              </li>
              <li>
                <a
                  href="#children-privacy"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Children's Privacy
                </a>
              </li>
              <li>
                <a
                  href="#changes-to-policy"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Changes to This Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="#contact-us"
                  style={{ color: "#333", textDecoration: "underline" }}
                >
                  Contact Us
                </a>
              </li>
            </ol>
          </div>

          <section id="information-we-collect" style={{ marginBottom: "40px" }}>
            <h2>1. Information We Collect</h2>

            <h3>1.1 Personal Information</h3>
            <p>We may collect the following types of personal information:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Account Information:</strong> Name, email address,
                password (securely hashed), phone number, and profile
                information
              </li>
              <li>
                <strong>Contact Information:</strong> Email address, phone
                number, and mailing address
              </li>
              <li>
                <strong>Payment Information:</strong> Credit card details
                (processed and stored by our PCI-compliant payment processor,
                Stripe), billing address, payment history, and subscription
                details
              </li>
              <li>
                <strong>Communication Data:</strong> Messages, feedback,
                customer support interactions, and contact form submissions
              </li>
              <li>
                <strong>Consent Records:</strong> Consent timestamps, verified
                status, consent tokens, and user agent data associated with
                consent actions
              </li>
            </ul>

            <h3>1.2 Email Analysis Data</h3>
            <p>When using our email security analysis services:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Email Content:</strong> Subject lines, message content
                (plain text and HTML), and metadata
              </li>
              <li>
                <strong>Attachments:</strong> Files attached to analyzed emails
              </li>
              <li>
                <strong>Sender Information:</strong> Email addresses and header
                information
              </li>
              <li>
                <strong>Analysis Results:</strong> AI-generated security
                assessments, threat classifications, and risk scores
              </li>
            </ul>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "15px",
                border: "1px solid #ddd",
                margin: "20px 0",
              }}
            >
              <p style={{ marginTop: "0" }}>
                <strong>
                  Important — Content You Submit or Forward for Analysis:
                </strong>{" "}
                When you forward an email or otherwise submit content (such as
                messages, images, screenshots, documents, or files) for
                analysis, that content is processed by KinShield and transmitted
                to third-party artificial intelligence and analysis providers
                (such as Anthropic and OpenAI). Forwarded or uploaded content
                may contain personal information about you and about third
                parties (for example, other senders, recipients, customers, or
                colleagues). We apply automated detection and redaction of
                certain personal information before AI processing, but this is
                not guaranteed to remove all sensitive information.
              </p>
              <p style={{ marginBottom: "0" }}>
                You are responsible for ensuring you are authorized to submit
                the content. Unless you have a separate written agreement with
                us that expressly permits it (for example, a Business Associate
                Agreement), you should not submit regulated, special-category,
                or privileged information — including protected health
                information (HIPAA), payment card data, student records (FERPA),
                or attorney-client privileged material. For business and
                corporate accounts, the organization is responsible for
                instructing its members accordingly. See our Terms and
                Conditions for the full list of prohibited content.
              </p>
            </div>

            <h3>1.3 SMS/Text Message Analysis Data</h3>
            <p>When using our SMS scam detection services:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Message Content:</strong> Text message content submitted
                for analysis
              </li>
              <li>
                <strong>Phone Numbers:</strong> Sender and recipient phone
                numbers
              </li>
              <li>
                <strong>Analysis Results:</strong> AI-generated scam assessments
                and threat indicators
              </li>
            </ul>

            <h3>1.4 Image and Screenshot Analysis Data</h3>
            <p>When using our image analysis features:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Uploaded Images:</strong> Image files (JPEG, PNG, GIF,
                WebP, HEIC, BMP) submitted for analysis
              </li>
              <li>
                <strong>Image Metadata:</strong> File size, MIME type, and
                dimensions (EXIF data is sanitized/stripped for privacy
                protection)
              </li>
              <li>
                <strong>Virus Scan Results:</strong> ClamAV malware scanning
                results for uploaded files
              </li>
              <li>
                <strong>AI Vision Analysis:</strong> AI-generated analysis of
                image content for scam indicators
              </li>
            </ul>

            <h3>1.5 Social Media Analysis Data</h3>
            <p>When using our social media scam detection features:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Social Media Content:</strong> Screenshots, posts,
                messages, or other social media content submitted for analysis
              </li>
              <li>
                <strong>Analysis Results:</strong> AI-generated scam assessments
                and risk indicators
              </li>
            </ul>

            <h3>1.6 URL and Phone Number Analysis Data</h3>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>URLs Submitted:</strong> Web addresses submitted for
                safety analysis, checked against Google Safe Browsing API,
                PhishTank, and other threat databases
              </li>
              <li>
                <strong>Domain Information:</strong> WHOIS registration data and
                SSL certificate information for analyzed domains
              </li>
              <li>
                <strong>Phone Numbers:</strong> Phone numbers submitted for scam
                verification, validated through IPQualityScore and other phone
                validation providers
              </li>
            </ul>

            <h3>1.7 Digital Personal Guard (DPG) Data</h3>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Chatbot Conversations:</strong> Messages and queries
                submitted to our AI-powered Digital Personal Guard chatbot
              </li>
              <li>
                <strong>Session Data:</strong> Conversation history, session
                identifiers, confidence scores, and diagnostic question
                responses
              </li>
              <li>
                <strong>Feedback:</strong> User feedback and ratings provided
                for chatbot interactions
              </li>
            </ul>

            <h3>1.8 Fraud Detection Pipeline Data</h3>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Documents and Files:</strong> PDFs, documents, and other
                files submitted for fraud analysis
              </li>
              <li>
                <strong>OCR Extracted Text:</strong> Text extracted from
                documents and images using optical character recognition (AWS
                Textract)
              </li>
              <li>
                <strong>QR Code Data:</strong> QR codes detected in submitted
                images
              </li>
              <li>
                <strong>PII Detection:</strong> Personally identifiable
                information detected and redacted from submitted content before
                AI analysis (using AWS Comprehend)
              </li>
            </ul>

            <h3>1.9 Browser Fingerprint and Device Data</h3>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "15px",
                border: "1px solid #ddd",
                margin: "20px 0",
              }}
            >
              <p>
                <strong>Important:</strong> We collect browser fingerprint data
                for security and fraud prevention purposes. This includes:
              </p>
              <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
                <li>Browser name, version, and rendering engine</li>
                <li>Operating system and device type, vendor, and model</li>
                <li>CPU architecture</li>
                <li>Screen resolution, color depth, and orientation</li>
                <li>
                  Storage capabilities (localStorage, sessionStorage, cookies)
                </li>
                <li>Canvas, WebGL, and audio fingerprint signatures</li>
                <li>Timezone, language, and regional settings</li>
                <li>Network connection information</li>
                <li>IP address and approximate geolocation</li>
              </ul>
              <p>
                This data is collected automatically at login and is used for
                device identification, risk scoring, fraud prevention, and
                account security.
              </p>
            </div>

            <h3>1.10 Training and Simulation Data</h3>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Training Progress:</strong> Courses completed, quiz
                scores, passing status, badges earned, certificates issued
              </li>
              <li>
                <strong>Simulation Performance:</strong> Emails opened, links
                clicked, response times, sophistication levels attempted,
                pass/fail results
              </li>
              <li>
                <strong>Risk and Safety Scores:</strong> Multi-criteria weighted
                safety scores, individual risk assessments, and vulnerability
                analysis results
              </li>
            </ul>

            <h3>1.11 Technical Information</h3>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Device Information:</strong> Browser type, operating
                system, device identifiers, and browser fingerprint data
              </li>
              <li>
                <strong>Usage Data:</strong> Pages viewed, features used,
                interaction patterns, and rate limiting counters
              </li>
              <li>
                <strong>Log Data:</strong> IP addresses, access times, error
                logs, and security audit events
              </li>
              <li>
                <strong>Performance Data:</strong> Response times and system
                performance metrics
              </li>
              <li>
                <strong>WebSocket Connection Data:</strong> Real-time connection
                state and notification delivery data
              </li>
            </ul>

            <h3>1.12 Business and Corporate Account Data</h3>
            <p>
              When you register for or are enrolled in a business, corporate, or
              other organizational ("Corporate") account, we collect and process
              the following additional information:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Company Profile Information:</strong> Company or
                organization name, description, industry classification, number
                of employees, derived company-size band, and account type
                (Business or Individual)
              </li>
              <li>
                <strong>Account Administrator Information:</strong> Identity,
                role, and contact details of the account owner and any account
                or group administrators authorized to manage the Corporate
                account
              </li>
              <li>
                <strong>Authorized User and Member Data:</strong> Names, work
                email addresses, phone numbers, group/team assignments, roles,
                seat allocation, and account status of employees or other
                individuals invited to or enrolled in the Corporate account
              </li>
              <li>
                <strong>Member Performance and Compliance Data:</strong>{" "}
                Training completion status, quiz scores, certificates, badges,
                simulation results, individual and group risk and safety scores,
                and other progress metrics that may be visible to account
                administrators
              </li>
              <li>
                <strong>Organizational Analytics:</strong> Aggregated and
                group-level dashboards, rollup reporting, and team-level risk
                and completion analytics generated from member activity
              </li>
              <li>
                <strong>Billing and Subscription Data:</strong> Plan or edition
                (including SMB/Corporate editions), seat count, billing contact,
                and subscription history associated with the Corporate account
              </li>
            </ul>
          </section>

          <section id="how-we-use-information" style={{ marginBottom: "40px" }}>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information for the following purposes:</p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>Service Provision:</strong> To provide and maintain our
                scam detection, analysis, training, and educational services
              </li>
              <li>
                <strong>AI-Powered Analysis:</strong> To process user-submitted
                content (emails, SMS, images, social media content, URLs, phone
                numbers, documents) through our AI systems for scam detection
                and fraud analysis. Your content may be sent to third-party AI
                service providers (such as Anthropic and OpenAI) for analysis.
                PII is detected and redacted before AI processing where
                applicable.
              </li>
              <li>
                <strong>Simulation and Training:</strong> To generate and
                deliver personalized cybersecurity training simulations,
                quizzes, and educational content using AI
              </li>
              <li>
                <strong>Risk Assessment:</strong> To calculate risk scores,
                safety scores, and vulnerability assessments based on your
                training performance and platform usage
              </li>
              <li>
                <strong>Security and Fraud Prevention:</strong> To protect
                accounts using browser fingerprinting, device identification,
                and risk scoring; to scan uploaded files for viruses and
                malware; and to prevent unauthorized access
              </li>
              <li>
                <strong>Account Management:</strong> To create and manage your
                account, process payments, verify identity, and provide customer
                support
              </li>
              <li>
                <strong>Communication:</strong> To send service updates,
                security alerts, simulation notifications, newsletters, and to
                respond to inquiries
              </li>
              <li>
                <strong>Improvement and Research:</strong> To improve our
                services, train and improve AI models, develop new features,
                conduct research, generate anonymized fraud intelligence, and
                enhance user experience
              </li>
              <li>
                <strong>Legal and Financial Compliance:</strong> To comply with
                legal obligations, respond to lawful requests, prevent fraud,
                enforce our terms, maintain financial records, and protect our
                rights. KinShield reserves a non-exclusive right to use and
                store the information users provide for effective analysis and
                financial and legal compliance with all applicable laws.
              </li>
              <li>
                <strong>Fraud Intelligence:</strong> To generate anonymized and
                de-identified fraud intelligence from user-submitted scam data
                for sharing with law enforcement, government agencies, and
                industry partners to combat fraud
              </li>
              <li>
                <strong>Corporate Account Administration:</strong> For business
                and corporate accounts, to provision seats, manage members,
                assign training and simulation campaigns, and provide account
                administrators with team-level dashboards, completion and
                compliance reporting, and aggregated risk analytics
              </li>
            </ul>
          </section>

          <section id="information-sharing" style={{ marginBottom: "40px" }}>
            <h2>3. Information Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or rent your personal information. We may
              share your information in the following circumstances:
            </p>

            <h3>3.1 Service Providers</h3>
            <p>
              We share information with the following categories of trusted
              third-party service providers who assist us in operating the
              Service:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                <strong>AI and Machine Learning Providers:</strong> Anthropic
                (Claude AI) and OpenAI for scam analysis, content generation,
                image vision analysis, and educational content. User-submitted
                content is processed by these providers to generate analyses and
                recommendations. Under our agreements with these providers, your
                submitted content is treated as confidential, is not used to
                train their AI models, and any international transfers are
                governed by appropriate safeguards such as Standard Contractual
                Clauses.
              </li>
              <li>
                <strong>Cloud Infrastructure:</strong> Amazon Web Services (AWS)
                for hosting, data storage (S3), serverless computing (Lambda),
                real-time messaging (API Gateway), caching (ElastiCache/Redis),
                database services (RDS, DynamoDB), content delivery
                (CloudFront), PII detection (Comprehend), OCR (Textract), email
                receiving (SES), security (WAF), monitoring (CloudWatch), and
                credential management (Secrets Manager)
              </li>
              <li>
                <strong>Payment Processing:</strong> Stripe for secure,
                PCI-compliant payment processing, subscription management, and
                recurring billing
              </li>
              <li>
                <strong>Email Delivery:</strong> SendGrid for transactional
                email delivery, verification emails, analysis result delivery,
                and newsletter distribution
              </li>
              <li>
                <strong>SMS and Phone Services:</strong> Twilio for SMS message
                sending/receiving, phone number verification (Verify API),
                simulation delivery, and webhook processing
              </li>
              <li>
                <strong>URL Threat Intelligence:</strong> Google Safe Browsing
                API and PhishTank for checking submitted URLs against known
                phishing and malicious URL databases
              </li>
              <li>
                <strong>Phone Number Validation:</strong> IPQualityScore,
                NumLookup, Numverify, and PhoneValidator for phone number scam
                verification and risk scoring
              </li>
              <li>
                <strong>Device Identification:</strong> FingerprintJS for
                browser fingerprinting and device identification for security
                purposes
              </li>
              <li>
                <strong>Security Scanning:</strong> ClamAV for virus and malware
                scanning of uploaded files
              </li>
              <li>
                <strong>Workflow Automation:</strong> n8n for powering the
                Digital Personal Guard chatbot service
              </li>
            </ul>

            <h3>3.2 Legal Requirements</h3>
            <p>We may disclose information when required by law or to:</p>
            <ul>
              <li>Comply with legal processes or government requests</li>
              <li>Protect our rights, property, or safety</li>
              <li>Prevent fraud or security threats</li>
              <li>Enforce our Terms of Service</li>
            </ul>

            <h3>3.3 Fraud Intelligence Sharing</h3>
            <p>
              We may share anonymized and de-identified fraud intelligence
              derived from user-submitted scam data with law enforcement
              agencies, government entities (such as the FTC, FBI IC3, and state
              attorneys general), industry partners, fraud prevention
              organizations, and research institutions for the purpose of
              combating fraud and protecting the public. We will never share
              personally identifiable victim information; only scam-side
              artifacts (e.g., fraudulent phone numbers, URLs, email addresses,
              and scam patterns) will be shared.
            </p>

            <h3>3.4 Business Transfers</h3>
            <p>
              In the event of a merger, acquisition, or sale of assets, your
              information may be transferred as part of the business
              transaction.
            </p>

            <h3>3.5 Within Your Organization (Corporate Accounts)</h3>
            <p>
              If you access the Service through a business, corporate, or other
              organizational account, your information — including your profile,
              training and simulation results, certificates, and individual and
              group risk and safety scores — may be accessible to the account
              owner and the account or group administrators authorized by your
              organization. Your organization, as the controller of that
              account, determines how this information is used and may use it
              for security awareness, compliance, and reporting purposes. Please
              refer to your organization's own privacy notice and policies for
              details on how it handles your information.
            </p>
          </section>

          <section id="data-security" style={{ marginBottom: "40px" }}>
            <h2>4. Data Security</h2>
            <p>
              We implement comprehensive security measures to protect your
              information:
            </p>
            <ul>
              <li>
                <strong>Encryption:</strong> Data is encrypted in transit and at
                rest using industry-standard protocols
              </li>
              <li>
                <strong>Access Controls:</strong> Strict access controls and
                authentication mechanisms
              </li>
              <li>
                <strong>Regular Audits:</strong> Regular security audits and
                vulnerability assessments
              </li>
              <li>
                <strong>Secure Infrastructure:</strong> Cloud infrastructure
                with enterprise-grade security
              </li>
              <li>
                <strong>Employee Training:</strong> Regular security training
                for all personnel
              </li>
            </ul>
          </section>

          <section id="data-retention" style={{ marginBottom: "40px" }}>
            <h2>5. Data Retention</h2>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "20px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "15px", border: "1px solid #ddd" }}>
                    <strong>Data Type</strong>
                  </th>
                  <th style={{ padding: "15px", border: "1px solid #ddd" }}>
                    <strong>Retention Period</strong>
                  </th>
                  <th style={{ padding: "15px", border: "1px solid #ddd" }}>
                    <strong>Purpose</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Account Information
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Duration of account + 30 days
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Account management and support
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Email, Text/SMS, and Social Media Analysis Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    7 days
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Service delivery and improvement
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Image Upload and Analysis Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    90 days (auto-cleanup)
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Security scanning and analysis
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    DPG Chatbot Conversation Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Duration of account
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Conversation continuity and service improvement
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Training and Simulation Performance Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Duration of account + anonymized indefinitely
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Progress tracking and service improvement
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Browser Fingerprint Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Duration of account
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Security and fraud prevention
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Payment Information
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    7 years
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Legal and tax compliance
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Consent Records
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    7 years or as required by law
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Legal compliance and consent verification
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Log Data
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    12 months
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Security and troubleshooting
                  </td>
                </tr>
                <tr>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Anonymized and Aggregated Fraud Intelligence
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Indefinitely
                  </td>
                  <td
                    style={{ padding: "12px 15px", border: "1px solid #ddd" }}
                  >
                    Fraud prevention and public safety
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <section id="your-rights" style={{ marginBottom: "40px" }}>
            <h2>6. Your Rights and Choices</h2>
            <p>
              You have the following rights regarding your personal information:
            </p>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "20px",
                border: "1px solid #ddd",
                marginBottom: "25px",
              }}
            >
              <h3 style={{ marginTop: "0" }}>General Rights</h3>
              <ul>
                <li>
                  <strong>Access:</strong> Request access to your personal
                  information
                </li>
                <li>
                  <strong>Correction:</strong> Request correction of inaccurate
                  information
                </li>
                <li>
                  <strong>Deletion:</strong> Request deletion of your personal
                  information
                </li>
                <li>
                  <strong>Portability:</strong> Request a copy of your data in a
                  structured format
                </li>
                <li>
                  <strong>Objection:</strong> Object to certain processing
                  activities
                </li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "20px",
                border: "1px solid #ddd",
                marginBottom: "25px",
              }}
            >
              <h3 style={{ marginTop: "0" }}>EU/UK Residents (GDPR)</h3>
              <ul>
                <li>Right to withdraw consent at any time</li>
                <li>Right to lodge a complaint with supervisory authorities</li>
                <li>Right to restrict processing in certain circumstances</li>
              </ul>
            </div>

            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "20px",
                border: "1px solid #ddd",
              }}
            >
              <h3 style={{ marginTop: "0" }}>California Residents (CCPA)</h3>
              <ul>
                <li>Right to know what personal information is collected</li>
                <li>Right to delete personal information</li>
                <li>Right to opt-out of the sale of personal information</li>
                <li>
                  Right to non-discrimination for exercising privacy rights
                </li>
              </ul>
            </div>

            <p style={{ marginTop: "25px" }}>
              <strong>Members of Business and Corporate Accounts:</strong> If
              you access the Service through a business or corporate account,
              your organization is the controller of your data and your rights
              requests may be directed to or coordinated with your organization.
              See the "Business and Corporate Accounts" section for details.
            </p>
          </section>

          <section id="cookies" style={{ marginBottom: "40px" }}>
            <h2>7. Cookies and Tracking Technologies</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Maintain your login session and authentication state</li>
              <li>Remember your preferences and settings</li>
              <li>Analyze usage patterns for service improvement</li>
              <li>Improve our services and user experience</li>
              <li>Enable browser fingerprinting for security purposes</li>
              <li>Support real-time WebSocket notifications</li>
              <li>Implement rate limiting and abuse prevention</li>
            </ul>
            <p>
              You can control cookies through your browser settings, but some
              features may not function properly if cookies are disabled.
            </p>
          </section>

          <section id="third-party-services" style={{ marginBottom: "40px" }}>
            <h2>8. Third-Party Services</h2>
            <p>
              Our service integrates with the following categories of
              third-party services:
            </p>
            <ul>
              <li>
                <strong>AI and Machine Learning Services:</strong> We use
                third-party AI providers (including Anthropic Claude and OpenAI)
                to analyze user-submitted content for scam detection, generate
                training simulations, and provide educational content. Your
                submitted content may be processed by these AI services.
                AI-generated analyses may contain errors, inaccuracies, or
                outdated information. We also use AWS Comprehend for PII
                detection and redaction, and AWS Textract for optical character
                recognition (OCR).
              </li>
              <li>
                <strong>Payment Processor:</strong> Stripe processes all payment
                transactions. We do not store your full credit card details on
                our servers.
              </li>
              <li>
                <strong>Communication Services:</strong> SendGrid for email
                delivery and Twilio for SMS messaging, phone verification, and
                simulation delivery.
              </li>
              <li>
                <strong>Threat Intelligence Services:</strong> Google Safe
                Browsing API and PhishTank for URL safety verification;
                IPQualityScore, NumLookup, Numverify, and PhoneValidator for
                phone number validation.
              </li>
              <li>
                <strong>Cloud Infrastructure:</strong> Amazon Web Services (AWS)
                for hosting, storage, computing, database, CDN, and security
                services.
              </li>
              <li>
                <strong>Device Identification:</strong> FingerprintJS for
                browser fingerprinting and device identification for security
                and fraud prevention.
              </li>
              <li>
                <strong>Security Scanning:</strong> ClamAV for virus and malware
                scanning of uploaded files.
              </li>
            </ul>
            <p>
              These services have their own privacy policies and terms. We
              encourage you to review them. We share only the minimum
              information necessary for each service to perform its function.
            </p>
          </section>

          <section
            id="business-corporate-accounts"
            style={{ marginBottom: "40px" }}
          >
            <h2>9. Business and Corporate Accounts</h2>
            <p>
              This section applies in addition to the rest of this Privacy
              Policy when you use the Service through a business, corporate, or
              other organizational ("Corporate") account, including our
              small-and-medium-business (SMB) and Corporate edition plans. In
              the event of a conflict, the terms of any separately executed
              business agreement or Data Processing Agreement between us and
              your organization will control with respect to member data.
            </p>

            <h3>9.1 Controller and Processor Roles</h3>
            <p>
              For Corporate accounts, the business or organization that
              establishes the account (the "Customer") is the data controller
              (or "business" under the CCPA) of the personal information of its
              authorized users, employees, and members. KinShield acts as a data
              processor (or "service provider") and processes that personal
              information solely to provide the Service in accordance with the
              Customer's documented instructions, our Terms and Conditions, and
              any applicable Data Processing Agreement. Where KinShield
              determines the purposes and means of processing (for example, for
              billing, security, fraud prevention, and service improvement), it
              acts as a controller for those limited purposes.
            </p>

            <h3>9.2 Account Administrator Access and Visibility</h3>
            <p>
              Corporate accounts are administered by an account owner and the
              account or group administrators they designate. These
              administrators may be able to access, view, manage, and export:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                Member profile and contact information, seat assignments, roles,
                and account status
              </li>
              <li>
                Training and simulation activity, completion and compliance
                status, quiz scores, certificates, and badges
              </li>
              <li>
                Individual and group risk and safety scores and vulnerability
                assessments
              </li>
              <li>
                Team-level dashboards, rollup reporting, and aggregated
                analytics
              </li>
            </ul>
            <p>
              If you are a member of a Corporate account, you acknowledge that
              your administrators have visibility into the data described above
              and that your use of the Service may be monitored and reported on
              by your organization for security awareness and compliance
              purposes.
            </p>

            <h3>9.3 Customer Responsibilities</h3>
            <p>
              As the controller of a Corporate account, the Customer is
              responsible for:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "30px" }}>
              <li>
                Establishing a valid legal basis for the collection and
                processing of member personal information
              </li>
              <li>
                Providing its members with all required privacy notices and
                obtaining any consents required by applicable law, including for
                phishing and social-engineering simulations and security
                awareness monitoring
              </li>
              <li>
                Complying with all applicable employment, privacy, workplace
                monitoring, and data protection laws in the jurisdictions where
                its members reside
              </li>
              <li>
                Ensuring that the personal information it provides or directs
                its members to provide is accurate and that it is authorized to
                share that information with us
              </li>
              <li>
                Managing administrator access responsibly and offboarding
                members promptly when access should be revoked
              </li>
            </ul>

            <h3>9.4 Privacy Rights for Members of Corporate Accounts</h3>
            <p>
              If your information is processed as part of a Corporate account
              and you wish to exercise the privacy rights described in this
              Policy (such as access, correction, or deletion), we may direct
              your request to your organization, which is the controller of your
              data. We will provide reasonable assistance to the Customer in
              responding to such requests and in fulfilling its data protection
              obligations.
            </p>

            <h3>9.5 Data Processing Agreement and Sub-Processors</h3>
            <p>
              Corporate Customers may enter into a Data Processing Agreement
              ("DPA") with us that governs our processing of member personal
              information, including, where applicable, the European
              Commission's Standard Contractual Clauses and equivalent UK
              transfer mechanisms for international data transfers. The DPA
              incorporates our use of the sub-processors described in Section 3
              (Information Sharing and Disclosure) and Section 8 (Third-Party
              Services). To request a DPA, contact us using the details in the
              "Contact Us" section.
            </p>

            <h3>9.6 Tenant Isolation and Data Segregation</h3>
            <p>
              Corporate account data is logically segregated on a per-account
              (multi-tenant) basis. Administrators of one Corporate account
              cannot access the data of another organization, and members are
              scoped to the account, group, and organization to which they
              belong.
            </p>

            <h3>9.7 Aggregated and De-Identified Insights</h3>
            <p>
              We may generate aggregated, anonymized, and de-identified
              statistics and benchmarks from Corporate account activity (for
              example, anonymized industry-level training and risk benchmarks).
              Such data does not identify any individual member or Customer and
              may be used to operate, secure, and improve the Service.
            </p>

            <h3>9.8 Return and Deletion of Member Data</h3>
            <p>
              Upon termination or expiration of a Corporate account, and subject
              to our legal and financial retention obligations described in the
              Data Retention section, we will, at the Customer's request, return
              or delete member personal information processed on the Customer's
              behalf in accordance with the applicable Data Processing
              Agreement.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "1px",
              backgroundColor: "#e0e0e0",
              margin: "30px 0",
            }}
          />

          <section
            id="international-transfers"
            style={{ marginBottom: "40px" }}
          >
            <h2>10. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries
              other than your own. We ensure adequate protection through:
            </p>
            <ul>
              <li>Adequacy decisions by relevant authorities</li>
              <li>Standard contractual clauses</li>
              <li>Certification schemes</li>
              <li>Other appropriate safeguards</li>
            </ul>
          </section>

          <section id="children-privacy" style={{ marginBottom: "40px" }}>
            <h2>11. Children's Privacy</h2>
            <p>
              Our service is not intended for children under 13 years of age. We
              do not knowingly collect personal information from children under
              13. If we become aware that we have collected such information, we
              will take steps to delete it promptly.
            </p>
          </section>

          <section id="changes-to-policy" style={{ marginBottom: "40px" }}>
            <h2>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of any material changes by:
            </p>
            <ul>
              <li>Posting the updated policy on our website</li>
              <li>Sending an email notification to registered users</li>
              <li>Displaying a prominent notice on our service</li>
            </ul>
            <p>
              Your continued use of our service after any changes constitutes
              acceptance of the updated Privacy Policy.
            </p>
          </section>

          <section id="contact-us" style={{ marginBottom: "40px" }}>
            <h2>13. Contact Us</h2>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                padding: "25px",
                border: "1px solid #ddd",
              }}
            >
              <p>
                If you have any questions about this Privacy Policy or our
                privacy practices, please contact us:
              </p>
              <ul style={{ listStyle: "none", padding: "0" }}>
                <li>
                  <strong>Email:</strong> info@kinprotect.com
                </li>
                <li>
                  <strong>Headquarters:</strong> Maryland, USA
                </li>
                <li>
                  <strong>Phone:</strong> 301-237-7843
                </li>
              </ul>
              <p>We will respond to your inquiry within 30 days.</p>
            </div>
          </section>

          <div
            style={{
              textAlign: "center",
              marginTop: "50px",
              padding: "25px",
              backgroundColor: "#f8f8f8",
              border: "1px solid #ddd",
            }}
          >
            <p style={{ margin: "0", color: "#666", fontStyle: "italic" }}>
              This Privacy Policy is effective as of August 1, 2025 and was last
              updated on June 26, 2026.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
